<template>
    <div v-for="checkbox in checkboxes" class="mx-2 my-4 w-full" :class="checkbox.Invalid ? 'border-l-8 border-red-700 pl-8' : null">
        <ValidationMessages v-if="checkbox.ValidationMessages" :messages="checkbox.ValidationMessages"></ValidationMessages>
        <div class="flex items-center" :class="checkbox.Invalid ? 'mt-4' : null">
            <input :id="checkbox.Id" type="checkbox" class="checkbox absolute top-0 left-0 w-8 h-8 opacity-0" />
            <label :for="checkbox.Id" :class="checkbox.Invalid ? 'checkbox-label-invalid' : null" class="relative checkbox-label leading-none h-8 flex pl-10 text-xl items-center text-gray-800">{{ checkbox.Label }}</label>
        </div>
    </div>
</template>

<script>
    import { default as ValidationMessages } from "../ValidationMessages.vue";

    export default {
        name: "Checkbox",
        components: {
            ValidationMessages,
        },
        data() {
            return {
                checkboxes: [
                    {
                        Id: 'ExampleCheckBox1',
                        Invalid: false,
                        ValidationMessages: [''],
                        Label: 'I agree that I like ice cream'
                    },
                    {
                        Id: 'ExampleCheckBox2',
                        Invalid: true,
                        ValidationMessages: ['You must agree that you like ice cream'],
                        Label: 'I agree that I like ice cream'
                    }
                ]
            }
        }
    };
</script>

<style>
    .checkbox-label::before {
        content: "";
        @apply absolute;
        @apply top-0;
        @apply left-0;
        @apply w-8;
        @apply h-8;
        @apply border-2;
        @apply border-gray-500;
    }

    .checkbox-label-invalid::before {
        @apply border-red-700;
    }

    .checkbox + .checkbox-label::after {
        content: "";
        @apply absolute;
        @apply w-6;
        @apply h-3;
        @apply border-solid;
        @apply opacity-0;
        @apply border-0;
        @apply border-b-4;
        @apply border-l-4;
        @apply border-blue-700;
        top: 7px;
        left: 4px;
        transform: rotate(-45deg);
    }

    .checkbox:checked + .checkbox-label::after {
        @apply opacity-100;
    }

    .checkbox:focus + .checkbox-label::before {
        @apply outline-0;
        box-shadow: 0 0 0 3px rgb(66 153 225 / 50%);
    }
</style>